import {SLIDE_NODE} from './Constants';
// function to fetchThe desiredSlide from list of slides at stateTree.notebook.protocolSection
export function fetchProtocolScene(allSlides, sceneType) {
  return allSlides.find((slide) => slide.type === sceneType);
}

// function to check if NodeOpearations Complete for DesignSlideTwo:
export function checkIfNodeComplete(nodeItem) {
  switch (nodeItem.nodeType) {
    case SLIDE_NODE.START_NODE:
    case SLIDE_NODE.BOX_DRAG_DROP:
    case SLIDE_NODE.JOINT_DRAG_DROP:
      return isNodeComplete(nodeItem);
    case SLIDE_NODE.JOINT_PATH_SELECT:
      return isPathSelectComplete(nodeItem);
    default:
      return false;
  }
}

function isNodeComplete(nodeItem) {
  return nodeItem.nodeComponents.every(
    (component) => component.id === component.droppedId
  );
}

function isPathSelectComplete(nodeItem) {
  let selectedNode = nodeItem.nodeOptions.find((option) => option.selected);
  if (selectedNode && selectedNode.id === nodeItem.nodeComponent) {
    return true;
  } else {
    return false;
  }
}

// to fetch all Id keys in ArrayOfObjects.
export function fetchComponentIds(componentList) {
  return componentList.map((listItem) => listItem.id);
}

// fetch the node with current: true
export function fetchCurrentNode(slideTree) {
  const findFromGroups = (currentNode, group) => {
    if (currentNode === null) {
      const current = group.groupNodes.find((node) => node.current === true);
      if (current) {
        currentNode = current;
      }
    }
    return currentNode;
  };
  return slideTree.reduce(findFromGroups, null);
}

// function to check if a DNDQ component is correct;
export function checkSlidersCorrect(sliders) {
  return sliders.reduce((boolVal, slider) => {
    if (
      boolVal === true &&
      slider.disable === false &&
      JSON.stringify(slider.answer) !== JSON.stringify(slider.current)
    ) {
      boolVal = false;
    }
    return boolVal;
  }, true);
}

// function to check if a GROUPED_DNDQ component is correct;
export function checkAllSliderGroupsCorrect(sliderGroups) {
  return sliderGroups.reduce((boolValue, group) => {
    const groupIsCorrect = checkSlidersCorrect(group.sliders);
    if (groupIsCorrect === false) {
      boolValue = false;
    }
    return boolValue;
  }, true);
}

// function to reset updated keyInList [parameter can be sliderGroups or sliders]
export function resetUpdatedKeyInDNDQ(sliderGroups) {
  return sliderGroups.map((group) => ({...group, updated: false}));
}

// function to check if checkbox/radio selection valid for CSCQ/MSCQ components
export function checkIfSelectionValid(component) {
  return (
    (component.totalAttempts === -10 || component.totalAttempts > 0) &&
      component.complete === false
    );
}

export function checkIfGroupedSelectionValid(component, correctSubmitted) {
  return (
    (component.totalAttempts === -10 || component.totalAttempts > 0) &&
      component.complete === false && !correctSubmitted
    );
}

//scrollTo top of the section
export function scrollToSectionTop(selector) {
  document.querySelector(selector).scrollTo(0, 0);
}

/**
 * Function that loops over GlossaryItems list
 * and classify them based on first letter
 */
const GLOSSARY_ITEM_TYPE = {
  VALUE: 'value',
  TITLE: 'title',
};
export function makeGroupedGlossaryList(glossaryList) {
  let {list} = glossaryList.reduce(
    ({category, list}, listItem, index) => {
      let firstLetter = listItem.title.substring(0, 1).toUpperCase();
      if (firstLetter === category) {
        list.push({...listItem, type: GLOSSARY_ITEM_TYPE.VALUE});
      } else {
        category = firstLetter;
        list.push({
          type: GLOSSARY_ITEM_TYPE.TITLE,
          title: firstLetter,
          id: `${index}_${firstLetter}`,
        });
        list.push({
          ...listItem,
          type: GLOSSARY_ITEM_TYPE.VALUE,
        });
      }
      return {category, list};
    },
    {category: null, list: []}
  );
  return list;
}
